import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'propertyByName',
})
export class PropertyByNamePipe implements PipeTransform {
  /**
   * Returns the value of a property by fieldName
   */
  transform(properties: any[], fieldName: string) {
    const filteredProperties = properties.filter(property => property.name === fieldName);

    if (filteredProperties && filteredProperties[0] && filteredProperties[0].value)  {
      return filteredProperties[0].value;
    }

    return '';
  }

  getOriginalValue(properties: any[], fieldName: string) {
    const filteredProperties = properties.filter(
      property => {
        if (property.name === fieldName) {
          return true;
        }
        return false;
      }
    );

    if (filteredProperties && filteredProperties[0] && filteredProperties[0].originalValue)  {
      return filteredProperties[0].originalValue;
    }

    return '';
  }

  getValue(properties: any[], fieldName: string) {
    const filteredProperties = properties.filter(property => property.name === fieldName);

    if (filteredProperties && filteredProperties[0] && filteredProperties[0].value)  {
      return filteredProperties[0].value;
    }

    return '';
  }

}
